import axiosConfig from '../axiosConfig';
import { TAppNotification } from '../types/AppNotification';

export class User {
	public static GetNotifications(): Promise<TAppNotification[]> {
		return axiosConfig.instance.get('admin/notifications').then((res) => {
			return res.data as TAppNotification[];
		});
	}
}
